import { useEffect, useState } from 'react';
import { Modal } from './shared/Modal';

const STORAGE_KEY = 'hawkeye-demo-warning-dismissed';

export function DemoWarningModal() {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    // Check if user has already dismissed the warning
    let shouldShowModal = false;
    
    try {
      const dismissed = localStorage.getItem(STORAGE_KEY);
      shouldShowModal = !dismissed;
    } catch (error) {
      // localStorage might be unavailable (private browsing, etc.)
      // Show the modal anyway to be safe
      shouldShowModal = true;
    }

    if (shouldShowModal) {
      // Show modal after a brief delay for better UX
      const timer = setTimeout(() => {
        setIsOpen(true);
      }, 500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleClose = () => {
    try {
      localStorage.setItem(STORAGE_KEY, 'true');
    } catch (error) {
      // Silently fail if localStorage is unavailable
      // Modal will still close, but may reappear on next visit
    }
    setIsOpen(false);
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} title="⚠️ Demo Site Warning">
      <div className="space-y-4">
        <p className="text-gray-300 text-base leading-relaxed">
          This site is still a <span className="font-semibold text-white">demo</span> and the data displayed is <span className="font-semibold text-white">fake</span>.
        </p>
        <p className="text-gray-300 text-base leading-relaxed">
          Please don't take the information seriously. This is for demonstration purposes only.
        </p>
        <div className="flex justify-end pt-2">
          <button
            onClick={handleClose}
            className="px-6 py-2 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-[#1a1f2e]"
          >
            I Understand
          </button>
        </div>
      </div>
    </Modal>
  );
}
